import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

import UserForm from "./../../components/page/boxiTeam/UserForm/UserForm";

class TeamUserPage extends Component {
  render() {
    const title = this.props.edit ? "Edit Boxi Team User" : "Create Boxi Team User";
    return (
      <Fragment>
        <Helmet>
          <title>Boxi Admin | {title}</title>
        </Helmet>
        <UserForm edit={this.props.edit} id={this.props.match.params.id} />
      </Fragment>
    );
  }
}

export default withRouter(TeamUserPage);
